var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check-circle",
    d: "M19,8A11,11,0,1,0,30,19,11,11,0,0,0,19,8Zm0,20.581A9.581,9.581,0,1,1,28.581,19,9.58,9.58,0,0,1,19,28.581Zm6.282-12.2-8.005,7.941a.532.532,0,0,1-.753,0l-3.809-3.84a.532.532,0,0,1,0-.753l.378-.375a.532.532,0,0,1,.753,0l3.059,3.084,7.249-7.191a.532.532,0,0,1,.753,0l.375.378a.532.532,0,0,1,0,.753Z",
    transform: "translate(-8 -8)",
    fill: "#118847"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-circle.617b4b1544bc32e1125dfdeeb8bc4764.svg";